window.onload = function() {
    console.log("Mega menu script geladen.");

    if (!window.navImages) {
        console.warn("window.navImages bestaat nog niet!");
        return;
    }

    // Containers selecteren
    var imageElement = document.querySelector("#NavigationTier2-1 > div > ul > li:nth-child(3) > div > div");
    var imageElement2 = document.querySelector("#NavigationTier2-1 > div > ul > li:nth-child(4) > div > div");

    if (!imageElement || !imageElement2) {
        console.warn("Een of beide containers niet gevonden!");
        return;
    }

    // ---------------------------
    // Functie om image 1 en 3 te vervangen/aanmaken
    // ---------------------------
    function replaceFirstImages() {
        // Image 1
        if (window.navImages.image1) {
            var img1 = imageElement.querySelector("img:first-of-type") || document.createElement('img');
            img1.src = window.navImages.image1;
            img1.alt = "Base Level Curvy 1";
            img1.removeAttribute('srcset');
            img1.removeAttribute('data-src');
            if (!img1.parentNode) imageElement.appendChild(img1);
        }

        // Image 3
        if (window.navImages.image3) {
            var img3 = imageElement2.querySelector("img:first-of-type") || document.createElement('img');
            img3.src = window.navImages.image3;
            img3.alt = "Base Level Curvy 3";
            img3.removeAttribute('srcset');
            img3.removeAttribute('data-src');
            if (!img3.parentNode) imageElement2.appendChild(img3);
        }

        console.log("Image 1 en 3 vervangen.");
    }

    // ---------------------------
    // MutationObserver instellen
    // ---------------------------
    var observerCallback = function(mutationsList, observer) {
        replaceFirstImages();
    };

    var observer = new MutationObserver(observerCallback);
    observer.observe(imageElement, { childList: true, subtree: true });
    observer.observe(imageElement2, { childList: true, subtree: true });

    // ---------------------------
    // Image 2 en 4 toevoegen (altijd)
    // ---------------------------
    if (window.navImages.image2) {
        var img2 = document.createElement('img');
        img2.src = window.navImages.image2;
        img2.alt = "Base Level Curvy 2";
        imageElement.appendChild(img2);
    }

    if (window.navImages.image4) {
        var img4 = document.createElement('img');
        img4.src = window.navImages.image4;
        img4.alt = "Base Level Curvy 4";
        imageElement2.appendChild(img4);
    }

    // Direct ook proberen (voor het geval images al in DOM staan)
    replaceFirstImages();

    // ---------------------------
    // Herhaaldelijk vervangen iedere 1 seconde gedurende 10 seconden
    // ---------------------------
    var repeatCount = 0;
    var maxRepeats = 10; // 10 seconden
    var interval = setInterval(function() {
        replaceFirstImages();
        repeatCount++;
        if (repeatCount >= maxRepeats) clearInterval(interval);
    }, 1000);

    console.log("Mega menu images geüpdatet!", window.navImages);
};
